import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button
} from 'shards-react';
import FeatherIcon from 'feather-icons-react';

import PageTitle from '../../../components/common/PageTitle';
import { REVIEW_GUIDE_SCENARIOS } from '../../../data/reviewGuideScenarios';
import './reviewGuide.scss';

@inject(({ Common }) => ({}))
@observer
class ReviewGuide extends Component {

  goTo = (path) => () => {
    if (this.props.history) {
      this.props.history.push(path);
    }
  };

  render() {
    return (
      <div className="main-content review-guide">
        <PageTitle />

        <Row>
          <Col>
            <Card small className="review-guide__intro mb-4">
              <CardBody>
                <h4 className="review-guide__intro-title">
                  핵심 기능을 시나리오에 맞게 조합해 보세요
                </h4>
                <p className="review-guide__intro-desc">
                  메뉴마다 흩어진 설정을 하나의 활용 시나리오로 묶어, 어떤 순서로 무엇을 설정해야 하는지 단계별로 안내합니다.
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {REVIEW_GUIDE_SCENARIOS.map((scenario) => (
          <Row key={scenario.id}>
            <Col>
              <Card small className="review-guide__scenario mb-4">
                <CardHeader className="review-guide__scenario-head">
                  <div className="review-guide__scenario-title">
                    <span className="review-guide__scenario-icon">
                      <FeatherIcon icon={scenario.icon} size={20} />
                    </span>
                    <h5 className="m-0">{scenario.title}</h5>
                  </div>
                  <p className="review-guide__scenario-summary m-0">{scenario.summary}</p>
                </CardHeader>

                <CardBody className="review-guide__steps-body">
                  <ol className="review-guide__steps">
                    {scenario.steps.map((step) => (
                      <li key={step.order} className="review-guide__step">
                        <div className="review-guide__step-head">
                          <span className="review-guide__step-badge">{step.order}</span>
                          <h6 className="review-guide__step-title m-0">{step.title}</h6>
                        </div>

                        <div className="review-guide__step-content">
                          <p className="review-guide__step-desc">{step.description}</p>
                          <Button
                            theme="accent"
                            outline
                            size="sm"
                            onClick={this.goTo(step.adminLink)}
                            className="review-guide__step-cta"
                          >
                            {step.linkLabel}
                            <FeatherIcon
                              icon="arrow-right"
                              size={14}
                              style={{ marginLeft: 4, verticalAlign: 'middle' }}
                            />
                          </Button>
                        </div>
                      </li>
                    ))}
                  </ol>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ))}
      </div>
    );
  }
}

export default ReviewGuide;
